import type { Observable } from 'rxjs'

export interface filterEntity {
  id: number
  name: string
}

// One page of a filter list, as loaded from the API.
export interface FilterPage {
  items: filterEntity[]
  hasNextPage: boolean
}

// Loads one page of a filter list, narrowed to the items whose name matches the search term.
export type FilterPageLoader = (
  search: string,
  page: number
) => Observable<FilterPage>

export const FILTER_PAGE_SIZE = 50

export interface stringMap {
  title: string
  key: string
}

export enum itemDialogOption {
  SEARCH,
}
